import { c as _c } from "react/compiler-runtime";
import { stegaClean } from "next-sanity";
import { cn } from "@repo/ui/utils.ts";
import { ImageWrapper } from "@/components/common/image/image.component";
import { BannerColorBlock } from "../banner-color-block";
import type { BannerDataItem, BannerVariant } from "./general-banner.types";
import { getImage, getContentBgClass } from "./general-banner.utils";
import { BannerContent } from "./banner-content.component";
export function BannerSingle(t0) {
  const $ = _c(35);
  const {
    item,
    variant,
    className
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = getImage(item);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const image = t1;
  let t2;
  if ($[2] !== item.maskedImage) {
    t2 = stegaClean(item.maskedImage) ?? "none" as const;
    $[2] = item.maskedImage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const maskedImage = t2;
  const hasMask = maskedImage !== "none";
  const isReversed = stegaClean(item.position) === "last";
  let imageColumn;
  let t3;
  if ($[4] !== hasMask || $[5] !== image || $[6] !== isReversed || $[7] !== item.colour || $[8] !== maskedImage || $[9] !== variant) {
    const contentBg = variant === "promo" ? getContentBgClass(item.colour) : variant === "feature" ? "" : "bg-surface-base-interactive";
    const t4 = isReversed && "tablet:order-2";
    let t5;
    if ($[12] !== t4) {
      t5 = cn("aspect-square overflow-hidden rounded-sm desktop:rounded-md", t4);
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== hasMask || $[15] !== image || $[16] !== item.colour || $[17] !== maskedImage) {
      t6 = hasMask && image ? <div className="h-full w-full"><BannerColorBlock image={image} maskedImage={maskedImage} colour={item.colour ?? undefined} className="aspect-auto h-full" /></div> : image ? <div className="h-full w-full"><ImageWrapper visual={image} className="h-full w-full" imgClassName="object-cover" /></div> : null;
      $[14] = hasMask;
      $[15] = image;
      $[16] = item.colour;
      $[17] = maskedImage;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    let t7;
    if ($[19] !== t5 || $[20] !== t6) {
      t7 = <div className={t5}>{t6}</div>;
      $[19] = t5;
      $[20] = t6;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    imageColumn = t7;
    t3 = cn("flex flex-col items-center justify-center px-6 py-10 tablet:pt-10 tablet:pb-12 text-center", isReversed && "tablet:order-1", contentBg);
    $[4] = hasMask;
    $[5] = image;
    $[6] = isReversed;
    $[7] = item.colour;
    $[8] = maskedImage;
    $[9] = variant;
    $[10] = imageColumn;
    $[11] = t3;
  } else {
    imageColumn = $[10];
    t3 = $[11];
  }
  let t4;
  if ($[22] !== item) {
    t4 = <div className="w-full max-w-md"><BannerContent item={item} /></div>;
    $[22] = item;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t3 || $[25] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  const contentColumn = t5;
  let t6;
  if ($[27] !== className) {
    t6 = cn(className);
    $[27] = className;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== contentColumn || $[30] !== imageColumn) {
    t7 = <div className="container-grid"><div className="col-span-full grid w-full grid-cols-1 tablet:grid-cols-2 overflow-hidden rounded-sm desktop:rounded-md desktop-lg:mx-auto ">{imageColumn}{contentColumn}</div></div>;
    $[29] = contentColumn;
    $[30] = imageColumn;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t6 || $[33] !== t7) {
    t8 = <section className={t6} data-testid="banner">{t7}</section>;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8;
}